module.exports = __webpack_public_path__ + "static/img/Bachelor_010233.e12a74f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010233.jpg
// module id = 124
// module chunks = 0